var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuoteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 62,
    viewBox: "0 0 78 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.048 61.584C1.856 52.464 0.26 43.42 0.26 34.452C0.26 24.116 2.996 15.832 8.468 9.6C13.94 3.21599 21.92 0.0239847 32.408 0.0239847V14.388C24.352 14.388 20.324 19.556 20.324 29.892V33.312H34.916V61.584H5.048ZM48.14 61.584C45.1 52.312 43.58 43.268 43.58 34.452C43.58 24.116 46.24 15.832 51.56 9.6C57.032 3.21599 65.012 0.0239847 75.5 0.0239847V14.388C67.596 14.388 63.644 19.556 63.644 29.892V33.312H78.008V61.584H48.14Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteIcon);
export default __webpack_public_path__ + "static/media/QuoteIcon.779912c0adf5f3938233eac3de756447.svg";
export { ForwardRef as ReactComponent };